import { z } from 'zod'

import { MetricPeriod, MetricType } from '../constants/metric'
import {
  admissionGroupMeasuresSchema,
  aggregateByAttributionItemSchema,
  aggregateByInventoryItemSchema,
  metricSchema,
} from './metric'
import { listQueryZodFields } from './system'

export const organizationMetricSchema = metricSchema
  .omit({
    venue: true,
  })
  .extend({
    organization: z.string(),
  })

export const organizationMetricsListQuerySchema = z.object({
  ...listQueryZodFields,
  organizationId: z.string(),
  name: z.string().optional(),
  search: z.string().optional(),
  type: z.array(z.nativeEnum(MetricType)).or(z.nativeEnum(MetricType)),
  period: z.nativeEnum(MetricPeriod),
  dateStart: z.coerce.date(),
  dateEnd: z.coerce.date(),
})

export const organizationMetricsListAggregateSchema = z.object({
  metrics: z.array(organizationMetricSchema),
  aggregate: admissionGroupMeasuresSchema.partial().optional(),
  aggregateByAttribution: z.array(aggregateByAttributionItemSchema).optional(),
  aggregateByInventory: z.array(aggregateByInventoryItemSchema).optional(),
})
